import React from 'react'
import cupidFetch from "../../modules/cupid-fetch"
import Activity, { activityFromJson } from '../../modules/data-objects/activity'
import ActivityListView from './activity-list-view'
import Subject from '../../modules/data-objects/subject'

class State {
    activities: Activity[] | null = null
}

class Props {
    queryString!: string
    reloadActivityList!: () => void
    subject!: Subject
}

class ActivityList extends React.Component<Props, State> {
    state: State = new State()
    mounted: boolean = false

    async componentDidMount() {
        this.mounted = true
        this.loadActivityList()
    }

    loadActivityList = async () => {
        const url = `/api/activities${this.props.queryString}`
        const activities = await cupidFetch<null, Activity[]>(url)
        if (!this.mounted) return
        if (activities) {
            this.setState({ activities: activities!.map(o => activityFromJson(o)) })
        }
    }

    reloadActivityList = async () => {
        await this.loadActivityList()
        this.props.reloadActivityList()
    }

    componentWillUnmount() {
        this.mounted = false
    }

    render() {
        return (
            <ActivityListView
                activities={this.state.activities}
                reloadActivityList={this.reloadActivityList}
                subject={this.props.subject} />
        )
    }
}

export default ActivityList
